import React, { useEffect } from "react";
import "./App.css";
import SpamForm from "./components/SpamForm";
import { initGA } from "./analytics";

function App() {
  useEffect(() => {
    initGA();
  }, []);

  return (
    <div className="container">
      <header>
        <span className="logo" style={{ display: "flex", alignItems: "center", fontWeight: "bold", fontSize: "1.2rem" }}>
          <svg width="24" height="24" fill="black" viewBox="0 0 24 24" style={{ marginRight: 8 }}>
            <rect x="2" y="4" width="20" height="16" rx="2" ry="2" fill="black"/>
            <polyline points="22,6 12,13 2,6" fill="none" stroke="white" strokeWidth="2"/>
          </svg>
          Spam Detector
        </span>
        <nav>
          <a href="#">Home</a>
          <a href="#">About</a>
          <a href="#">Contact</a>
          <button className="sign-up">Sign Up</button>
        </nav>
      </header>
      <main>
        <section className="hero-section" style={{ textAlign: 'center' }}>
          <h1 style={{ fontSize: '3rem', fontWeight: '800', marginBottom: '1rem', textTransform: 'uppercase', letterSpacing: '2px' }}>EMAIL SPAM DETECTOR</h1>
          <p className="subtitle">Protect your inbox with AI-powered spam detection</p>
          <p className="description">Advanced AI technology to detect spam, phishing, and malicious emails. Analyze suspicious emails, URLs, and EML files instantly for free.</p>
        </section>
        <section className="detection-tool">
          <SpamForm />
        </section>
        <section className="features" style={{ marginTop: '2rem', padding: '1rem', textAlign: 'center' }}>
          <h2>Why Choose Our Email Spam Detector?</h2>
          <div className="feature-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem', marginTop: '1.5rem', maxWidth: '1000px', margin: '1.5rem auto 0' }}>
            <div className="feature">
              <h3>🤖 AI-Powered Detection</h3>
              <p>Advanced machine learning algorithms trained on millions of spam patterns</p>
            </div>
            <div className="feature">
              <h3>⚡ Instant Analysis</h3>
              <p>Get results in seconds with real-time email content analysis</p>
            </div>
            <div className="feature">
              <h3>🛡️ Phishing Protection</h3>
              <p>Detect sophisticated phishing attempts and malicious URLs</p>
            </div>
            <div className="feature">
              <h3>📁 EML File Support</h3>
              <p>Analyze email files directly with comprehensive header inspection</p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default App;
